import { getToolTypeLabel } from '@backrs_ui/common-ui/src/models/tool';
var DEGREE_CODE_BADGE_LABEL = {
    bachelors: 'University',
    graduate: 'University',
    associates: '2-Year College',
    certificate: 'Trades/Technical School',
    not_classified: 'College',
};
export var getInstitutionBadgeLabel = function (predominantDegreeCode) {
    return (predominantDegreeCode && DEGREE_CODE_BADGE_LABEL[predominantDegreeCode]) || 'College';
};
var DEGREE_CODE_BADGE_ICON = {
    bachelors: 'Building08',
    graduate: 'Building08',
    associates: 'FileShield02',
    certificate: 'Tool01',
    not_classified: 'GraduationHat02',
};
export var getInstitutionBadgeIcon = function (predominantDegreeCode) {
    return (predominantDegreeCode && DEGREE_CODE_BADGE_ICON[predominantDegreeCode]) || 'GraduationHat02';
};
var BACKRS_LOGO_VARIANTS = new Set([
    'deep-dive',
    'playlist',
    'tool',
    'solution-session',
]);
export var FEATURED_ICON_BG_COLOR_MAP = {
    'deep-dive': 'Brand/600',
    playlist: 'Brand/800',
    tool: 'Brand/500',
    'solution-session': 'Brand/50',
    'career-path': 'Brand/600',
    major: 'Error/400',
    competency: 'Brand/200',
    'educational-investment': 'Brand/800',
    industry: 'Brand/50',
    'career-track': 'Brand/600',
};
var VARIANT_BADGE_ICON_MAP = {
    article: 'File06',
    'video-external': 'PlayCircle',
    'video-internal': 'PlayCircle',
    opportunity: 'ArrowCircleBrokenRight',
    scholarships: 'CurrencyDollarCircle',
    employer: 'Building06',
    institution: 'CurrencyDollarCircle',
    'career-path': 'Briefcase01',
    major: 'Certificate01',
    competency: 'CheckVerified03',
    'educational-investment': 'Building08',
    industry: 'Building07',
    coach: 'User02',
    event: 'CalendarPlus01',
    audio: 'VolumeMin',
    document: 'File06',
    book: 'BookOpen01',
    resource: 'BookOpen01',
    'text-response': 'BookOpen01',
    'generated-content': 'File02',
    'career-track': 'Rocket02',
    'track-assessment-result': 'File02',
    'track-assessment-unlock': 'LockKeyholeSquare',
    'profile-external': 'User02',
    'profile-internal': 'User02',
    internship: 'Briefcase01',
    post: 'Edit05',
};
var VARIANT_BADGE_LABEL_MAP = {
    article: 'Article',
    'video-external': 'Video',
    'video-internal': 'Video',
    opportunity: 'Opportunity',
    scholarships: 'Scholarship',
    employer: 'Employer',
    'career-path': 'Career Path',
    major: 'College Major',
    competency: 'Competency',
    'educational-investment': 'Educational Investment',
    industry: 'Industry',
    coach: 'Coach',
    'deep-dive': 'Deep Dive',
    playlist: 'Playbook',
    tool: 'Tool',
    'solution-session': 'Solution Session',
    event: 'Event',
    audio: 'Audio',
    document: 'Document',
    book: 'Book',
    resource: 'Resource',
    'text-response': 'Resource',
    'generated-content': 'For You',
    'career-track': 'Career Track',
    'track-assessment-result': 'For You',
    'track-assessment-unlock': 'Four Unlocks',
    'profile-external': 'Profile',
    'profile-internal': 'Profile',
    internship: 'Internship',
    post: 'Post',
};
export var INTERNSHIP_ROLE_LABEL_MAP = {
    'Junior IC': 'Full-time',
    Intern: 'Internship',
};
export var getInternshipRoleLabel = function (roleType) { var _a; return roleType ? ((_a = INTERNSHIP_ROLE_LABEL_MAP[roleType]) !== null && _a !== void 0 ? _a : roleType) : undefined; };
export var getNuggetCardBadge = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var variant = _a.variant, predominantDegreeCode = _a.predominantDegreeCode, profileImageUrl = _a.profileImageUrl, formattedDate = _a.formattedDate, roleType = _a.roleType, awardType = _a.awardType, toolType = _a.toolType;
    if (variant === 'tool') {
        return {
            label: getToolTypeLabel(toolType),
            iconConfig: { mode: 'backrsLogo' },
        };
    }
    if (variant === 'text-response' && profileImageUrl) {
        return {
            label: 'Resume',
            iconConfig: { mode: 'avatar', avatarUrl: profileImageUrl },
        };
    }
    if (variant === 'internship') {
        return {
            label: (_b = getInternshipRoleLabel(roleType)) !== null && _b !== void 0 ? _b : 'Opportunity',
            iconConfig: { mode: 'appIcon', icon: (_c = VARIANT_BADGE_ICON_MAP.internship) !== null && _c !== void 0 ? _c : 'Briefcase01' },
        };
    }
    if (variant === 'scholarships') {
        return {
            label: (_d = awardType !== null && awardType !== void 0 ? awardType : VARIANT_BADGE_LABEL_MAP.scholarships) !== null && _d !== void 0 ? _d : 'Scholarship',
            iconConfig: {
                mode: 'appIcon',
                icon: (_e = VARIANT_BADGE_ICON_MAP.scholarships) !== null && _e !== void 0 ? _e : 'CurrencyDollarCircle',
            },
        };
    }
    if (variant === 'generated-content' && formattedDate) {
        return {
            label: formattedDate,
            iconConfig: { mode: 'appIcon', icon: 'MessageSquare02' },
        };
    }
    if (BACKRS_LOGO_VARIANTS.has(variant)) {
        return {
            label: (_f = VARIANT_BADGE_LABEL_MAP[variant]) !== null && _f !== void 0 ? _f : variant
                .split('-')
                .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                .join(' '),
            iconConfig: { mode: 'backrsLogo' },
        };
    }
    if (variant === 'institution') {
        return {
            label: getInstitutionBadgeLabel(predominantDegreeCode),
            iconConfig: { mode: 'appIcon', icon: getInstitutionBadgeIcon(predominantDegreeCode) },
        };
    }
    var icon = (_g = VARIANT_BADGE_ICON_MAP[variant]) !== null && _g !== void 0 ? _g : 'InfoCircle';
    var label = (_h = VARIANT_BADGE_LABEL_MAP[variant]) !== null && _h !== void 0 ? _h : variant
        .split('-')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(' ');
    if (process.env.NODE_ENV === 'development' &&
        (!VARIANT_BADGE_ICON_MAP[variant] || !VARIANT_BADGE_LABEL_MAP[variant])) {
        console.warn("[NuggetCard] No badge mapping for variant \"".concat(variant, "\" \u2014 using fallback"));
    }
    return {
        label: label,
        iconConfig: { mode: 'appIcon', icon: icon },
    };
};
export var getFeaturedIconBgColor = function (variant) {
    return FEATURED_ICON_BG_COLOR_MAP[variant];
};
